/* (v147) OCR: a scanned PDF made searchable.
   Every page without text is drawn with pdf.js (about 300 dpi, within a
   pixel ceiling), read by tesseract.js (Tesseract OCR in WebAssembly, in its
   own worker) and Tesseract's own "text only" PDF of that page (invisible
   text in render mode 3, every word at its place and width, the GlyphLessFont
   that maps any Unicode letter) is laid over the ORIGINAL page with pdf-lib.
   The page itself stays exactly as it was. The engine, its WebAssembly core
   and the language data all come from /vendor/ on this site; a language is
   only downloaded when it is chosen. */
(function(){
  'use strict';
  var T = window.PCTools;
  if(!T) return;

  var VENDOR = { worker: '/vendor/tesseract-7.0.0/worker.min.js', core: '/vendor/tesseract-7.0.0/', langs: '/vendor/tessdata-4.0.0_best_int' };
  // download sizes in MB, for the "loading" message (the core: one of the three builds plus the worker script, as the server sends them compressed; the .gz language files don't shrink further)
  var CORE_MB = 1.5;
  var LANG_MB = { eng: 2.9, nld: 3.0, fra: 0.7, deu: 1.3, spa: 2.1, por: 1.4, ita: 1.7, pol: 2.6 };
  var MAX_LANGS = 3;
  var OEM_LSTM_ONLY = 1;
  var OCR_DPI = 300, PT_PER_INCH = 72;
  var MAX_PIXELS = 12e6, PHONE_MAX_PIXELS = 6e6, MAX_SIDE = 8000; // A4 at 300 dpi is 8.7 MP
  var TEXT_PAGE_MIN_CHARS = 25; // a stamped page number alone doesn't make a scan a text page
  var MANY_PAGES = 15, SEC_PER_PAGE = 6; // warning above this many pages, with a rough time

  var MSG = {
    en: {
      ocrWorking: 'Recognising text…',
      ocrLoading: 'Loading text recognition (about {0} MB, only the first time)…',
      ocrPage: 'Recognising page {0} of {1}…',
      ocrFilePage: '{0}: recognising page {1} of {2}…',
      ocrInfoOne: '1 PDF, text recognised on {0} of {1} pages',
      ocrInfoMany: '{0} PDFs made searchable',
      ocrSkippedNote: '{0} page(s) already had text and were skipped. Choose “All pages” to recognise them anyway.',
      ocrEmptyNote: 'No text was found on {0} page(s).',
      ocrCheckNote: 'Recognition is never flawless: check the result before you rely on it.',
      ocrAllText: 'every page already has text. Choose “All pages” to recognise it again.',
      ocrNoText: 'no text was recognised on any page (handwriting and photos often fail).',
      ocrNoLang: 'Choose at least one language.',
      ocrLoadFailed: 'Text recognition could not be loaded. Check your connection and try again.',
      ocrPageFailed: 'Text recognition failed on page {0}.',
      ocrManyPages: '{0} pages: this takes about {1} min. Keep this tab open.',
      ocrPhoneWarn: 'Text recognition needs a lot of memory on a phone or tablet: recognise a few pages at a time if the page stops responding.'
    },
    nl: {
      ocrWorking: 'Tekst herkennen…',
      ocrLoading: 'Tekstherkenning laden (ongeveer {0} MB, alleen de eerste keer)…',
      ocrPage: 'Pagina {0} van {1} herkennen…',
      ocrFilePage: '{0}: pagina {1} van {2} herkennen…',
      ocrInfoOne: "1 PDF, tekst herkend op {0} van {1} pagina's",
      ocrInfoMany: "{0} PDF's doorzoekbaar gemaakt",
      ocrSkippedNote: "{0} pagina('s) hadden al tekst en zijn overgeslagen. Kies „Alle pagina's” om ze toch te herkennen.",
      ocrEmptyNote: "Op {0} pagina('s) is geen tekst gevonden.",
      ocrCheckNote: 'Herkenning is nooit foutloos: kijk het resultaat na voor je erop vertrouwt.',
      ocrAllText: "elke pagina heeft al tekst. Kies „Alle pagina's” om ze opnieuw te herkennen.",
      ocrNoText: "op geen enkele pagina is tekst herkend (handschrift en foto's lukken vaak niet).",
      ocrNoLang: 'Kies minstens één taal.',
      ocrLoadFailed: 'De tekstherkenning kon niet laden. Controleer je verbinding en probeer opnieuw.',
      ocrPageFailed: 'De tekstherkenning is mislukt op pagina {0}.',
      ocrManyPages: "{0} pagina's: dit duurt ongeveer {1} min. Laat dit tabblad open.",
      ocrPhoneWarn: "Tekstherkenning vraagt veel geheugen op een smartphone of tablet: herken een paar pagina's tegelijk als de pagina niet meer reageert."
    },
    fr: {
      ocrWorking: 'Reconnaissance du texte…',
      ocrLoading: 'Chargement de la reconnaissance de texte (environ {0} Mo, la première fois seulement)…',
      ocrPage: 'Reconnaissance de la page {0} sur {1}…',
      ocrFilePage: '{0} : reconnaissance de la page {1} sur {2}…',
      ocrInfoOne: '1 PDF, pages avec texte reconnu : {0} sur {1}',
      ocrInfoMany: '{0} PDF rendus consultables',
      ocrSkippedNote: '{0} page(s) contenaient déjà du texte et ont été ignorées. Choisissez « Toutes les pages » pour les reconnaître quand même.',
      ocrEmptyNote: 'Aucun texte trouvé sur {0} page(s).',
      ocrCheckNote: 'La reconnaissance n’est jamais parfaite : vérifiez le résultat avant de vous y fier.',
      ocrAllText: 'chaque page contient déjà du texte. Choisissez « Toutes les pages » pour le reconnaître à nouveau.',
      ocrNoText: 'aucun texte n’a été reconnu (l’écriture manuscrite et les photos échouent souvent).',
      ocrNoLang: 'Choisissez au moins une langue.',
      ocrLoadFailed: 'La reconnaissance de texte n’a pas pu être chargée. Vérifiez votre connexion et réessayez.',
      ocrPageFailed: 'La reconnaissance de texte a échoué à la page {0}.',
      ocrManyPages: '{0} pages : cela prend environ {1} min. Laissez cet onglet ouvert.',
      ocrPhoneWarn: 'La reconnaissance de texte demande beaucoup de mémoire sur un smartphone ou une tablette : traitez quelques pages à la fois si la page ne répond plus.'
    },
    de: {
      ocrWorking: 'Text wird erkannt…',
      ocrLoading: 'Texterkennung wird geladen (etwa {0} MB, nur beim ersten Mal)…',
      ocrPage: 'Seite {0} von {1} wird erkannt…',
      ocrFilePage: '{0}: Seite {1} von {2} wird erkannt…',
      ocrInfoOne: '1 PDF, Text auf {0} von {1} Seiten erkannt',
      ocrInfoMany: '{0} PDFs durchsuchbar gemacht',
      ocrSkippedNote: '{0} Seite(n) hatten bereits Text und wurden übersprungen. Wählen Sie „Alle Seiten“, um sie trotzdem zu erkennen.',
      ocrEmptyNote: 'Auf {0} Seite(n) wurde kein Text gefunden.',
      ocrCheckNote: 'Texterkennung ist nie fehlerfrei: Prüfen Sie das Ergebnis, bevor Sie sich darauf verlassen.',
      ocrAllText: 'jede Seite hat bereits Text. Wählen Sie „Alle Seiten“, um ihn erneut zu erkennen.',
      ocrNoText: 'auf keiner Seite wurde Text erkannt (Handschrift und Fotos gelingen oft nicht).',
      ocrNoLang: 'Wählen Sie mindestens eine Sprache.',
      ocrLoadFailed: 'Die Texterkennung konnte nicht geladen werden. Prüfen Sie Ihre Verbindung und versuchen Sie es erneut.',
      ocrPageFailed: 'Die Texterkennung ist auf Seite {0} fehlgeschlagen.',
      ocrManyPages: '{0} Seiten: Das dauert etwa {1} Min. Lassen Sie diesen Tab geöffnet.',
      ocrPhoneWarn: 'Texterkennung braucht auf einem Smartphone oder Tablet viel Speicher: Erkennen Sie wenige Seiten auf einmal, wenn die Seite nicht mehr reagiert.'
    },
    es: {
      ocrWorking: 'Reconociendo el texto…',
      ocrLoading: 'Cargando el reconocimiento de texto (unos {0} MB, solo la primera vez)…',
      ocrPage: 'Reconociendo la página {0} de {1}…',
      ocrFilePage: '{0}: reconociendo la página {1} de {2}…',
      ocrInfoOne: '1 PDF, texto reconocido en {0} de {1} páginas',
      ocrInfoMany: '{0} PDF convertidos en buscables',
      ocrSkippedNote: '{0} página(s) ya tenían texto y se omitieron. Elige «Todas las páginas» para reconocerlas igualmente.',
      ocrEmptyNote: 'No se encontró texto en {0} página(s).',
      ocrCheckNote: 'El reconocimiento nunca es perfecto: revisa el resultado antes de fiarte de él.',
      ocrAllText: 'todas las páginas ya tienen texto. Elige «Todas las páginas» para reconocerlo de nuevo.',
      ocrNoText: 'no se reconoció texto en ninguna página (la escritura a mano y las fotos suelen fallar).',
      ocrNoLang: 'Elige al menos un idioma.',
      ocrLoadFailed: 'No se pudo cargar el reconocimiento de texto. Comprueba tu conexión e inténtalo de nuevo.',
      ocrPageFailed: 'El reconocimiento de texto falló en la página {0}.',
      ocrManyPages: '{0} páginas: tardará unos {1} min. Deja esta pestaña abierta.',
      ocrPhoneWarn: 'El reconocimiento de texto necesita mucha memoria en un móvil o una tableta: reconoce pocas páginas a la vez si la página deja de responder.'
    },
    pt: {
      ocrWorking: 'Reconhecendo o texto…',
      ocrLoading: 'Carregando o reconhecimento de texto (cerca de {0} MB, só na primeira vez)…',
      ocrPage: 'Reconhecendo a página {0} de {1}…',
      ocrFilePage: '{0}: reconhecendo a página {1} de {2}…',
      ocrInfoOne: '1 PDF, texto reconhecido em {0} de {1} páginas',
      ocrInfoMany: '{0} PDFs pesquisáveis criados',
      ocrSkippedNote: '{0} página(s) já tinham texto e foram puladas. Escolha “Todas as páginas” para reconhecê-las mesmo assim.',
      ocrEmptyNote: 'Nenhum texto foi encontrado em {0} página(s).',
      ocrCheckNote: 'O reconhecimento nunca é perfeito: confira o resultado antes de confiar nele.',
      ocrAllText: 'todas as páginas já têm texto. Escolha “Todas as páginas” para reconhecê-lo de novo.',
      ocrNoText: 'nenhum texto foi reconhecido em nenhuma página (letra à mão e fotos costumam falhar).',
      ocrNoLang: 'Escolha pelo menos um idioma.',
      ocrLoadFailed: 'Não foi possível carregar o reconhecimento de texto. Verifique sua conexão e tente de novo.',
      ocrPageFailed: 'O reconhecimento de texto falhou na página {0}.',
      ocrManyPages: '{0} páginas: isso leva cerca de {1} min. Deixe esta aba aberta.',
      ocrPhoneWarn: 'O reconhecimento de texto usa muita memória em um celular ou tablet: reconheça poucas páginas por vez se a página parar de responder.'
    },
    it: {
      ocrWorking: 'Riconoscimento del testo…',
      ocrLoading: 'Download del riconoscimento del testo (circa {0} MB, solo la prima volta)…',
      ocrPage: 'Riconoscimento della pagina {0} di {1}…',
      ocrFilePage: '{0}: riconoscimento della pagina {1} di {2}…',
      ocrInfoOne: '1 PDF, pagine con testo riconosciuto: {0} su {1}',
      ocrInfoMany: '{0} PDF resi ricercabili',
      ocrSkippedNote: '{0} pagina/e avevano già del testo e sono state saltate. Scegli «Tutte le pagine» per riconoscerle comunque.',
      ocrEmptyNote: 'Nessun testo trovato su {0} pagina/e.',
      ocrCheckNote: 'Il riconoscimento non è mai perfetto: controlla il risultato prima di fidarti.',
      ocrAllText: 'ogni pagina ha già del testo. Scegli «Tutte le pagine» per riconoscerlo di nuovo.',
      ocrNoText: 'nessun testo è stato riconosciuto (scrittura a mano e foto spesso non riescono).',
      ocrNoLang: 'Scegli almeno una lingua.',
      ocrLoadFailed: 'Non è stato possibile caricare il riconoscimento del testo. Controlla la connessione e riprova.',
      ocrPageFailed: 'Il riconoscimento del testo non è riuscito a pagina {0}.',
      ocrManyPages: '{0} pagine: ci vorranno circa {1} min. Lascia aperta questa scheda.',
      ocrPhoneWarn: 'Il riconoscimento del testo richiede molta memoria su smartphone o tablet: riconosci poche pagine alla volta se la pagina smette di rispondere.'
    }, pl: {
      ocrWorking: "Rozpoznawanie tekstu…",
      ocrLoading: "Pobieranie rozpoznawania tekstu (ok. {0} MB, tylko za pierwszym razem)…",
      ocrPage: "Rozpoznawanie strony {0} z {1}…",
      ocrFilePage: "{0}: rozpoznawanie strony {1} z {2}…",
      ocrInfoOne: "1 PDF, strony z rozpoznanym tekstem: {0} z {1}",
      ocrInfoMany: "Włączono wyszukiwanie w {0} {0#pliku|plikach|plikach} PDF",
      ocrSkippedNote: "{0} {0#strona miała|strony miały|stron miało} już tekst i {0#została pominięta|zostały pominięte|zostało pominiętych}. Wybierz „Wszystkie strony”, aby mimo to je rozpoznać.",
      ocrEmptyNote: "Nie znaleziono tekstu na {0} {0#stronie|stronach|stronach}.",
      ocrCheckNote: "Rozpoznawanie nigdy nie jest doskonałe: sprawdź wynik, zanim mu zaufasz.",
      ocrAllText: "każda strona ma już tekst. Wybierz „Wszystkie strony”, aby rozpoznać go ponownie.",
      ocrNoText: "nie rozpoznano żadnego tekstu (pismo odręczne i zdjęcia często się nie udają).",
      ocrNoLang: "Wybierz co najmniej jeden język.",
      ocrLoadFailed: "Nie udało się wczytać rozpoznawania tekstu. Sprawdź połączenie i spróbuj ponownie.",
      ocrPageFailed: "Rozpoznawanie tekstu nie powiodło się na stronie {0}.",
      ocrManyPages: "{0} {0#strona|strony|stron}: to potrwa ok. {1} min. Nie zamykaj tej karty.",
      ocrPhoneWarn: "Rozpoznawanie tekstu wymaga dużo pamięci na smartfonie lub tablecie: jeśli strona przestanie reagować, rozpoznawaj po kilka stron naraz."
    }
  };
  var LANG = (document.documentElement.lang || 'en').slice(0, 2).toLowerCase();
  var M = MSG[LANG] || MSG.en;
  function t(key){
    var s = M[key] != null ? M[key] : MSG.en[key];
    return pcFill.apply(null, [s].concat(Array.prototype.slice.call(arguments, 1)));
  }
  function ownError(text, field){
    var e = new Error(text);
    e.userFacing = true;
    if(field) e.field = true;
    return e;
  }

  /* ---- the options ---- */
  function langBoxes(){ return Array.prototype.slice.call(document.querySelectorAll('#ocr-langs input[type="checkbox"]')); }
  function chosenLangs(){ return langBoxes().filter(function(b){ return b.checked; }).map(function(b){ return b.value; }); }
  // at most MAX_LANGS: once that many are ticked, the others can't be (more languages = slower and less accurate)
  function limitLangs(){
    var full = chosenLangs().length >= MAX_LANGS;
    langBoxes().forEach(function(b){ b.disabled = full && !b.checked; });
  }

  /* ---- the engine: one tesseract.js worker per run, started at the first page that needs it ---- */
  /* p, but rejected at once by Cancel (a terminated tesseract worker never settles its job). */
  function untilCancel(p){
    return new Promise(function(resolve, reject){
      var stop = function(){ reject(pcCancelError()); };
      pcCancelHooks.add(stop);
      if(pcCancel.requested) stop();
      p.then(resolve, reject).then(function(){ pcCancelHooks.delete(stop); });
    });
  }
  /* tesseract.js rejects with a plain string; a full memory in its WebAssembly is said as such */
  function engineFault(e, key, arg){
    if(pcIsCancel(e)) return e;
    var err = e instanceof Error ? e : new Error(String(e));
    pcLogUnexpected(err);
    return /out of memory|\bOOM\b|memory access/i.test(err.message) ? pcUserError(pcT('outOfMemory')) : ownError(t(key, arg));
  }
  function absolute(path){ return new URL(path, location.href).href; }
  function downloadMb(langs){ return Math.round(langs.reduce(function(s, l){ return s + LANG_MB[l]; }, CORE_MB)); }
  /* (v149) the Italian traineddata asks for a user-words file (user_words_suffix "special-words") that
     doesn't exist: tesseract printed a console error on every Italian run (the result was right).
     No user words in any language, so the setting is switched off at init. */
  /* (v164) Tesseract's own warnings (tprintf: "Image too small to scale!!", "Line cannot be
     recognized!!" for specks and 1-2 px lines on a scanned page) went to the console as errors,
     dozens per page; the result was right. They go to its debug file, which is no file. A real
     failure still rejects the job (engineFault). */
  var INIT_PARAMS = { user_words_suffix: '', debug_file: '/dev/null' };
  function newEngine(langs, ctx){
    var engine = { worker: null, starting: null, onProgress: null };
    var stop = function(){ if(engine.worker) engine.worker.terminate(); };
    pcCancelHooks.add(stop); // Cancel ends the worker at once, which frees all of its memory
    engine.get = async function(){
      if(engine.worker) return engine.worker;
      await pcLoadLib('tesseract');
      ctx.setStatus(t('ocrLoading', downloadMb(langs)));
      engine.starting = window.Tesseract.createWorker(langs, OEM_LSTM_ONLY, {
        workerPath: absolute(VENDOR.worker), corePath: absolute(VENDOR.core), langPath: absolute(VENDOR.langs),
        workerBlobURL: false, // a blob: worker would need another CSP source; this one is a file of this site
        gzip: true, cacheMethod: 'none', // the service worker and the browser cache keep the files; no second copy in IndexedDB
        logger: function(m){ if(engine.onProgress && m.status === 'recognizing text') engine.onProgress(m.progress); },
        errorHandler: function(){ /* the same error rejects the job's promise, which is handled where it is awaited */ }
      }, INIT_PARAMS);
      try{ engine.worker = await untilCancel(engine.starting); }
      catch(e){
        // Cancel while it loads: the worker that still arrives is ended at once
        if(pcIsCancel(e)) engine.starting.then(function(w){ w.terminate(); }, pcLogUnexpected);
        throw engineFault(e, 'ocrLoadFailed');
      }
      return engine.worker;
    };
    engine.close = function(){
      pcCancelHooks.delete(stop);
      stop();
      engine.worker = null;
    };
    return engine;
  }

  /* ---- one page ---- */
  async function pageHasText(page){
    var tc = await page.getTextContent(), n = 0;
    for(var i = 0; i < tc.items.length; i++){
      n += (tc.items[i].str || '').replace(/\s+/g, '').length;
      if(n >= TEXT_PAGE_MIN_CHARS) return true;
    }
    return false;
  }
  /* The page as shown (crop box, /Rotate), as a PNG of about OCR_DPI within the pixel ceiling. */
  async function renderPage(page, turn){
    turn = turn || 0;
    var vp1 = page.getViewport({ scale: 1 });
    var maxPx = pcIsPhone() ? PHONE_MAX_PIXELS : MAX_PIXELS;
    var scale = Math.min(OCR_DPI / PT_PER_INCH, MAX_SIDE / vp1.width, MAX_SIDE / vp1.height, Math.sqrt(maxPx / (vp1.width * vp1.height)));
    // (v157) turn: an extra clockwise turn, to read a page that was scanned sideways or upside down
    var vp = page.getViewport({ scale: scale, rotation: (page.rotate + turn) % 360 });
    var canvas = document.createElement('canvas');
    try{
      canvas.width = Math.max(1, Math.floor(vp.width));
      canvas.height = Math.max(1, Math.floor(vp.height));
      var g = pcCanvas2d(canvas);
      g.fillStyle = '#ffffff';
      g.fillRect(0, 0, canvas.width, canvas.height);
      await page.render({ canvasContext: g, viewport: vp }).promise;
      var png = await new Promise(function(res){ canvas.toBlob(res, 'image/png'); });
      if(!png) throw pcUserError(pcT('outOfMemory')); // the page rendered: no image means no memory left
      return { png: png, dpi: Math.round(scale * PT_PER_INCH) };
    }finally{
      canvas.width = canvas.height = 0;
    }
  }
  /* Tesseract's text-only PDF of the page image, or null when it found no text. */
  async function recognize(engine, img, p){
    var w = await engine.get();
    try{
      await untilCancel(w.setParameters({ user_defined_dpi: String(img.dpi) })); // its PDF page size; no "invalid resolution" guess
      var r = await untilCancel(w.recognize(img.png, { pdfTitle: '', pdfTextOnly: true }, { text: true, pdf: true }));
      return r.data.text.trim() ? { pdf: new Uint8Array(r.data.pdf), conf: r.data.confidence || 0 } : null;
    }catch(e){ throw engineFault(e, 'ocrPageFailed', p); }
  }
  /* (v157) A page scanned sideways or upside down gave nonsense text (and
     "recognised"): when the reading is poor, the three other turns are read
     too and the clearly best one is kept. */
  var TURNS = [90, 180, 270], CONF_GOOD = 60, CONF_BETTER = 15;
  async function recognizeTurned(engine, page, p){
    var best = await recognize(engine, await renderPage(page, 0), p);
    if(best && best.conf >= CONF_GOOD) return Object.assign(best, { turn: 0 });
    best = best ? Object.assign(best, { turn: 0 }) : null;
    for(var i = 0; i < TURNS.length; i++){
      pcCheckCancel();
      var r = await recognize(engine, await renderPage(page, TURNS[i]), p);
      if(r && (!best || r.conf > best.conf + CONF_BETTER)) best = Object.assign(r, { turn: TURNS[i] });
    }
    return best;
  }
  /* The invisible text page over the original one, across the visible box as the reader shows it;
     (v157) read at an extra clockwise turn, it is turned back (counter-clockwise) onto the page. */
  var TURN_ORIGIN = { 0: [0, 0], 90: [1, 0], 180: [1, 1], 270: [0, 1] }; // in visible widths/heights
  async function overlay(doc, index, ocrPdf, turn){
    turn = turn || 0;
    var emb = (await doc.embedPdf(ocrPdf, [0]))[0];
    var page = doc.getPage(index), f = pcVisualFrame(page), o = TURN_ORIGIN[turn];
    var at = f.toUser(o[0] * f.vw, o[1] * f.vh), side = turn % 180 !== 0;
    page.drawPage(emb, { x: at[0], y: at[1], width: side ? f.vh : f.vw, height: side ? f.vw : f.vh, rotate: PDFLib.degrees((f.rot + turn) % 360) });
  }

  /* ---- one file ---- */
  async function openPdfJs(file){
    var task = pcGetDocument(pcPdfSource(new Uint8Array(await file.arrayBuffer())));
    try{ return { task: task, pdf: await task.promise }; }
    catch(e){
      await task.destroy();
      if(pcIsCancel(e) || (e && e.userFacing)) throw e;
      pcThrowIfOutOfMemory(e);
      throw T.userError(e && e.name === 'PasswordException' ? 'password' : 'invalidPdf');
    }
  }
  function warnOnce(run, ctx, n){
    if(run.warned || n <= MANY_PAGES) return;
    run.warned = true;
    run.warnings.push(t('ocrManyPages', n, Math.max(1, Math.round(n * SEC_PER_PAGE / 60))));
    ctx.warn(run.warnings.join(' '));
  }
  async function ocrFile(file, index, run, ctx){
    var doc = await T.loadPdfLib(file); // a broken, cut-off or protected file stops here with its own message
    var opened = await openPdfJs(file), pdf = opened.pdf, n = pdf.numPages;
    var count = { done: 0, hadText: 0, empty: 0 };
    // at the first page that needs OCR: the time warning (for the pages from here on), the engine, the page's status again
    // (reads the loop's current p, label and frac below)
    var prepare = async function(){
      warnOnce(run, ctx, n - p + 1);
      await run.engine.get();
      ctx.setStatus(label);
      run.engine.onProgress = frac;
    };
    try{
      for(var p = 1; p <= n; p++){
        pcCheckCancel();
        var label = run.files > 1 ? t('ocrFilePage', file.name, p, n) : t('ocrPage', p, n);
        var frac = function(x){ ctx.setProgress((index + (p - 1 + x) / n) / run.files); };
        ctx.setStatus(label);
        frac(0);
        await ocrPage(doc, pdf, p, run, count, prepare);
      }
    }finally{
      await opened.task.destroy();
    }
    if(!count.done) throw ownError(t(count.hadText === n ? 'ocrAllText' : 'ocrNoText'));
    run.done += count.done; run.pages += n; run.hadText += count.hadText; run.empty += count.empty;
    pcCheckCancel();
    return { blob: T.pdfBlob(await pcSavePdf(doc)), filename: baseFileName(file.name) + '-ocr.pdf' };
  }
  async function ocrPage(doc, pdf, p, run, count, prepare){
    var page = await pdf.getPage(p);
    try{
      if(!run.redo && await pageHasText(page)){ count.hadText++; return; }
      await prepare();
      var ocr = await recognizeTurned(run.engine, page, p);
      if(!ocr){ count.empty++; return; }
      await overlay(doc, p - 1, ocr.pdf, ocr.turn);
      count.done++;
    }finally{
      page.cleanup();
    }
  }

  function resultText(out, run){
    var info = out.results.length === 1 ? t('ocrInfoOne', run.done, run.pages) : t('ocrInfoMany', out.results.length);
    var notes = [T.takeNotes(), run.hadText ? t('ocrSkippedNote', run.hadText) : '', run.empty ? t('ocrEmptyNote', run.empty) : '', t('ocrCheckNote')];
    return { info: info, note: notes.filter(Boolean).join(' ') };
  }

  pcOnPanel('ocr', function(){
    langBoxes().forEach(function(b){ b.addEventListener('change', limitLangs); });
    limitLangs();
    T.setupTool('ocr', {
      accept: T.isPdf, optionsId: 'ocr-mode-options', fieldId: 'ocr-langs', zipName: 'ocr-pdf',
      working: function(){ return t('ocrWorking'); },
      run: async function(files, mode, ctx){
        var langs = chosenLangs();
        if(!langs.length) throw ownError(t('ocrNoLang'), true);
        pcRequirePdfJs();
        T.resetNotes();
        var run = { files: files.length, redo: mode === 'all', engine: newEngine(langs, ctx), warned: false, warnings: [], done: 0, pages: 0, hadText: 0, empty: 0 };
        if(pcIsPhone()){ run.warnings.push(t('ocrPhoneWarn')); ctx.warn(run.warnings[0]); }
        try{
          var out = await T.eachFile(files, ctx, function(file, i){ return ocrFile(file, i, run, ctx); });
          return Object.assign(out, resultText(out, run));
        }finally{
          run.engine.close();
        }
      }
    });
  });
})();
